import React, { memo, useState } from "react";
import { Menu, MenuItem, Button, Box, Stack, Typography, Avatar, Chip } from "@mui/material";
import { citiesInIndia, CREATOR_CATEGORY, CREATOR_GENDER, FOLLOWERS_ARRAY, getFixedValue, INFLUNCER_SEARCH_FILTERS } from "../../utils/constant";
import rightCaret from '../../assets/images/icons/rightCaret.svg'
import { useDispatch, useSelector } from "react-redux";
import { getInfluencerListFordashboard } from './action';
import { updateDashboard } from './dashboardSlice';
import { capitalizeWords, setSearchdata } from "../../utils/common";
import DeleteIcon from "../../assets/images/icons/X.svg";
import FilterIcon from '../../assets/images/icons/filterIcon.svg'
const NestedDropdown = memo(() => {
  const [anchorEl, setAnchorEl] = useState(null);
  const {
    filters, totalCount
  } = useSelector((state) => state.dashboardSlice);
  const dispatch = useDispatch();
  const handleMenuOpen = (event) => {
    if (anchorEl) return;
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <Box>
        <Stack direction="row" spacing={2} sx={{ alignItems: 'center', }}>

          <Button onClick={handleMenuOpen} sx={{
            "& .MuiTouchRipple-root": { color: "var(--color-blue) !important" },
            height:'40px',width:'108px',
            alignItems: 'center', display: 'flex', gap: '4px', borderRadius: '50px', padding: '0px',border:'1px solid #F0F0F0', color: 'black', "&:hover": { backgroundColor: 'transparent !important' }
          }}>
            <img src={FilterIcon} alt="filtericon" width={20} height={20} />
            <Typography sx={{ fontWeight: '500 !important', fontSize: '16px !important', p: 0, m: 0, fontFamily: 'var(--family1)', whiteSpace: 'nowrap', }}>Filter</Typography></Button>
          <Box sx={{
            display: "flex",
            flexWrap: "wrap",
            gap: 1,
            rowGap: 2,
            justifyContent: "flex-start"
          }}>
            {INFLUNCER_SEARCH_FILTERS?.filter((item) => filters[item.key]).map((f) => (
              <>
                <Chip
                  key={f}
                  label={f.name + ': ' + (capitalizeWords(filters[f.key]) === " " ? 'All' : capitalizeWords(filters[f.key]))}
                  variant="outlined"
                  onClick={() => { }}
                  onDelete={() => {
                    dispatch(updateDashboard({showLoading:true,list:[], filters: { ...filters, [f.key]: "" }, page: 1 ,limit:30,totalCount:0}));
                    dispatch(getInfluencerListFordashboard());
                  }}
                  deleteIcon={
                    <img src={DeleteIcon} alt="delete icon" height={24} width={24} />
                  }
                  sx={{ borderRadius: '5px', border: '1px solid var(--color-blue)', color: 'var(--color-blue)', }}
                />
              </>
            ))
            }
          </Box>
          <Typography sx={{ color: "#726C6C !important", fontWeight: '600 !important', fontSize: '14px !important', p: 0, m: 0, fontFamily: 'var(--family1)', whiteSpace: 'nowrap' }}>{getFixedValue(totalCount)} Results</Typography>
          <Button onClick={() => {
            dispatch(updateDashboard({ showLoading:true,list:[],filters: { platform: filters.platform }, page: 1,limit:30, totalCount:0,}))
            setSearchdata(JSON.stringify({ platform: filters.platform || "Instagram", }));
            dispatch(getInfluencerListFordashboard());
          }} sx={{ fontWeight: '600 !important', fontSize: '14px !important', p: 0, m: 0, fontFamily: 'var(--family1)', whiteSpace: 'nowrap', color: 'var(--color-blue)' }}>Clear Filter</Button>
        </Stack>
      </Box>
      {Boolean(anchorEl) && (<NestedMenu menuItems={menuData} parentAnchorEl={anchorEl} onClose={handleMenuClose} />)}

    </div>
  );
});

export default NestedDropdown;


const menuData = [
  {
    label: "Location",
    children: [
      { label: "Pan India", value: " ", key: 'location' },
    ],
    key: 'location'
  },
  {
    label: "Gender",
    children: [
      { label: "Gender (All)", value: ' ', key: 'gender', },
    ],
    key: 'gender',
  },
  {
    label: "Followers",
    children: [
      { label: "Followers (All)", value: ' ', key: 'influencerType', },
    ],
    key: 'influencerType',
  },
  {
    label: "Category",
    children: [
      { label: "Category (All)", value: ' ', key: 'creatorCategory' },
    ],
    key: 'creatorCategory'
  },
];

menuData?.map((item) => {
  if (item.label === 'Location') {
    const citiesLabel = citiesInIndia?.filter((v) => v !== " Pan India")?.map((c) => ({ label: c, value: c, key: 'location' }));
    item.children = [...item.children, ...citiesLabel];
  }
  if (item.label === 'Gender') {
    const genders = CREATOR_GENDER?.map((g) => ({ label: g, value: g, key: 'gender' }));
    item.children = [...item.children, ...genders]
  }
  if (item.label === 'Followers') {
    const follower = FOLLOWERS_ARRAY?.map((g) => ({ label: g.label, value: g.value, key: 'influencerType' }));
    item.children = [...item.children, ...follower]
  }
  if (item.label === 'Category') {
    const category = CREATOR_CATEGORY?.map((g) => ({ label: g, value: g, key: 'creatorCategory' }));
    item.children = [...item.children, ...category]
  }
  return item;
})


const NestedMenu = memo(({ menuItems, parentAnchorEl, onClose, depth = 0, anchorOrigin = { vertical: 'bottom', horizontal: 'left', }, marginMenuLeft = '0', key = 0 }) => {
  const [openMenus, setOpenMenus] = useState({});
  const dispatch = useDispatch();
  const {
    filters
  } = useSelector((state) => state.dashboardSlice);
  const handleMenuClick = (event, index) => {
    setOpenMenus((prev) => ({
      ...Object.keys(prev).reduce((acc, key) => ({ ...acc, [key]: null }), {}), // Close all other menus
      [index]: prev[index] ? null : event.currentTarget,
    }));
  };

  const handleItemClick = (event, item, index) => {
    if (item.children) {
      handleMenuClick(event, index);
    } else {
      switch (item.key) {
        case 'location':
          dispatch(updateDashboard({ showLoading:true,list:[],filters: { ...filters, location: item.value }, page: 1,limit:30,totalCount:0, }));
          dispatch(getInfluencerListFordashboard());
          break;
        case 'gender':
          dispatch(updateDashboard({showLoading:true, list:[],filters: { ...filters, gender: item.value }, page: 1,limit:30,totalCount:0 }));
          dispatch(getInfluencerListFordashboard());
          break;
        case 'influencerType':
          dispatch(updateDashboard({showLoading:true, list:[],filters: { ...filters, influencerType: item.value }, page: 1,limit:30,totalCount:0 }));
          dispatch(getInfluencerListFordashboard());
          break;
        case 'creatorCategory':
          dispatch(updateDashboard({showLoading:true, list:[],filters: { ...filters, creatorCategory: item.value }, page: 1,limit:30,totalCount:0}));
          dispatch(getInfluencerListFordashboard());
          break;
        default:
      }
      onClose();
    }
  };


  return (
    <>
      {<Menu

        disablePortal
        className="custom-filter-discovery"
        anchorEl={parentAnchorEl}
        open={Boolean(parentAnchorEl)}
        onClose={onClose}
        sx={{
          maxHeight: '350px', marginLeft: `${marginMenuLeft}`,
          borderRadius: '12px',
        }}
        anchorOrigin={
          depth === 0
            ? { vertical: "bottom", horizontal: "left" }
            : { vertical: "top", horizontal: "right" }
        }
        transformOrigin={{ vertical: "top", horizontal: "left" }}
      >
        {menuItems.map((item, index) => (
          <>
            <MenuItem
              sx={{
                borderBottom: '1px solid #EEE', display: 'flex', justifyContent: 'space-between',
                alignItems: 'center !important', padding: '10px 0px !important', "&:hover": { background: '#0077FF1A' }, "& .MuiTouchRipple-root": { color: "var(--color-blue) !important" },
              }}
              key={`${depth}-${index}`}
              onClick={(event) => {
                handleItemClick(event, item, index);
              }}
              value={item.value || ""}
              defaultValue=""
            >
              <Box sx={{ flexGrow: 1, px: 2 }}>{item.label}</Box>
              {item.children && <Box sx={{ pr: 2 }}><Avatar src={rightCaret} alt="caret" sx={{ height: '20px', width: '20px' }} /></Box>}
            </MenuItem>
            {item.children && (
              <NestedMenu
                marginMenuLeft="5px"
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                menuItems={item.children}
                parentAnchorEl={openMenus[index]}
                onClose={onClose}
                depth={depth + 1}
              />
            )}
          </>
        ))}
      </Menu>}
    </>
  );
});